import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "./StudentFeedbackForm.css";
import TextInput from "../../common/FormFields/TextInput.jsx";
import SelectInput from "../../common/FormFields/SelectInput.jsx";
import FileInput from "../../common/FormFields/FileInput.jsx";


const FeedbackTest = () => {
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email format").required("Email is required"),
    contactNumber: Yup.string().required("Contact number is required"),
    course: Yup.string().required("Course is required"),
  });

  const [passportPhoto, setPassportPhoto] = useState(null);
  const [aadharFront, setAadharFront] = useState(null);
  const [aadharBack, setAadharBack] = useState(null);

  return (
    <div className="formContainer">
      <h2>Feedback Form</h2>
      <Formik
        initialValues={{
          name: "",
          email: "",
          contactNumber: "",
          course: "",
          gender: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log(values);
        }}
      >
        {() => (
          <Form>
            <TextInput label="Name" name="name" />
            <TextInput label="Email" name="email" type="email" />
            <TextInput label="Contact Number" name="contactNumber" type="tel" />
            <TextInput label="Course" name="course" />

            <SelectInput
              label="Gender"
              name="gender"
              options={[
                { label: "Select", value: "" },
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
                { label: "Other", value: "other" },
              ]}
            />

            <FileInput
              label="Passport Size Photo"
              name="passportPhoto"
              setPhoto={setPassportPhoto}
              photoPreview={passportPhoto}
            />
            <FileInput
              label="Aadhar Front Photo"
              name="aadharFront"
              setPhoto={setAadharFront}
              photoPreview={aadharFront}
            />
            <FileInput
              label="Aadhar Back Photo"
              name="aadharBack"
              setPhoto={setAadharBack}
              photoPreview={aadharBack}
            />

            <button type="submit" className="submitButton">
              Submit
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FeedbackTest;
